export default {
  // API_ENDPOINT: "http://localhost:8000/api",
  API_ENDPOINT: "https://stormy-cliffs-13063.herokuapp.com/api",
  TOKEN_KEY: "bookery-client-auth-token",
  USER_ID: "bookery-user-id"
}